import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BusVideos, Calendar, Swap } from '../../assests/ExportImageIcon'
import MainTab from '../../componants/mainTab/MainTab'
import PopularDestination from '../popularDestination/PopularDestination'
import SpecialOffer from '../specialOffer/SpecialOffer'
import InfluencerReels from '../influencerReels/InfluencerReels'
import GetApp from '../getApp/GetApp'
import OurLatestBlog from '../ourLatestblog/OurLatestBlog'

// This page is a static placeholder — no bus search/booking API exists yet, so the
// search widget below is hardcoded to match the reference design exactly (no
// AirportAutocomplete/DatePicker, no state, no click behaviour). Once a bus API is
// available, this can be wired up the same way flight.jsx/cruise.jsx are.
const TRIP_TABS = [
  { value: 'oneway', label: 'Oneway' },
  { value: 'round_trip', label: 'Round-Trip' },
]

// Full functional version (flight-search-style, API-wired) — kept for when a bus
// API exists. See flight.jsx for the live reference this was based on.
//
// import { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { useNavigate } from 'react-router-dom'
// import { User } from '../../assests/ExportImageIcon'
// import AirportAutocomplete from '../../componants/airportAutocomplete/AirportAutocomplete'
// import DatePicker from '../../componants/datePicker/DatePicker'
// import service from '../../services/service'
// import endpoints from '../../services/endpoints'
// import { showToast } from '../../componants/toast/toastService'
// import { setBootstrap, setFlightSearching, setResults, setSearchParams } from '../../redux/flightSearch/flightSearchSlice'
// import { setActiveSearchNonce, resetFlightBooking } from '../../redux/flightBooking/flightBookingSlice'
// import { generateSearchNonce } from '../../utils/bookingNonce'
//
// const FALLBACK_TRIP_TYPES = [
//     { value: 'oneway', label: 'Oneway' },
//     { value: 'round_trip', label: 'Round-Trip' },
// ]
//
// const MIN_LEGS = 2
// const MAX_LEGS = 4
//
// const todayIso = () => new Date().toISOString().split('T')[0]
//
// let legIdSeq = 1
// const newLeg = () => ({ id: legIdSeq++, fromAirport: null, toAirport: null, departureDate: '' })
//
// const BusBooking = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const bootstrap = useSelector((state) => state.flightSearch.bootstrap)
//
//     const [tripType, setTripType] = useState('oneway')
//     const [fromAirport, setFromAirport] = useState(null)
//     const [toAirport, setToAirport] = useState(null)
//     const [departureDate, setDepartureDate] = useState('')
//     const [returnDate, setReturnDate] = useState('')
//     const [legs, setLegs] = useState([newLeg(), newLeg()])
//     const [cabin, setCabin] = useState('economy')
//     const [adults, setAdults] = useState(1)
//     const [specialFares, setSpecialFares] = useState({})
//     const [bootstrapFailed, setBootstrapFailed] = useState(false)
//
//     useEffect(() => {
//         service
//             .get(endpoints.bookings.searchHome, { service: 'flight' }, { silent: true })
//             .then(({ data }) => {
//                 dispatch(setBootstrap(data.data))
//             })
//             .catch(() => {
//                 setBootstrapFailed(true)
//                 showToast('Unable to load search options right now. Please try again later.', 'error')
//             })
//     }, [dispatch])
//
//     const cabinClasses = bootstrap?.dropdown_options?.cabin_classes || []
//     const specialFareOptions = bootstrap?.dropdown_options?.special_fares || []
//     const popularAirports = bootstrap?.dropdown_options?.popular_airports || []
//     const tripTypes = bootstrap?.dropdown_options?.trip_types || FALLBACK_TRIP_TYPES
//
//     const toggleSpecialFare = (key) => {
//         setSpecialFares((prev) => ({ ...prev, [key]: !prev[key] }))
//     }
//
//     const swapAirports = () => {
//         setFromAirport(toAirport)
//         setToAirport(fromAirport)
//     }
//
//     const updateLeg = (id, patch) => {
//         setLegs((prev) => prev.map((leg) => (leg.id === id ? { ...leg, ...patch } : leg)))
//     }
//
//     const addLeg = () => {
//         setLegs((prev) => (prev.length >= MAX_LEGS ? prev : [...prev, newLeg()]))
//     }
//
//     const removeLeg = (id) => {
//         setLegs((prev) => (prev.length > MIN_LEGS ? prev.filter((leg) => leg.id !== id) : prev))
//     }
//
//     const handleSearch = () => {
//         dispatch(resetFlightBooking())
//         dispatch(setActiveSearchNonce(generateSearchNonce()))
//
//         const basePayload = {
//             travellers: { adults, children: 0, infants: 0 },
//             cabin,
//             student_fare: !!specialFares.student,
//             armed_forces: !!specialFares.armed_forces,
//             senior_citizen: !!specialFares.senior_citizen,
//             direct_only: false,
//             refundable_only: false,
//             nearby_airports: true,
//             preferred_airlines: '',
//         }
//
//         const params = {
//             tripType,
//             adults,
//             children: 0,
//             infants: 0,
//             cabin,
//             studentFare: basePayload.student_fare,
//             armedForces: basePayload.armed_forces,
//             seniorCitizen: basePayload.senior_citizen,
//             directOnly: false,
//             refundableOnly: false,
//             nearbyAirports: true,
//             preferredAirlines: '',
//         }
//
//         let searchPayload
//
//         if (tripType === 'multi_city') {
//             if (legs.some((leg) => !leg.fromAirport || !leg.toAirport || !leg.departureDate)) {
//                 showToast('Please fill in all cities and dates for every leg', 'error')
//                 return
//             }
//             searchPayload = {
//                 ...basePayload,
//                 trip_type: tripType,
//                 legs: legs.map((leg) => ({
//                     from_airport: leg.fromAirport.code,
//                     to_airport: leg.toAirport.code,
//                     departure_date: leg.departureDate,
//                 })),
//             }
//             params.legs = legs.map(({ fromAirport: f, toAirport: t, departureDate: d }) => ({ fromAirport: f, toAirport: t, departureDate: d }))
//             params.fromAirport = legs[0].fromAirport
//             params.toAirport = legs[legs.length - 1].toAirport
//             params.departureDate = legs[0].departureDate
//             params.returnDate = ''
//         } else {
//             if (!fromAirport || !toAirport) {
//                 showToast('Please select both departure and destination airports', 'error')
//                 return
//             }
//             if (!departureDate) {
//                 showToast('Please select a departure date', 'error')
//                 return
//             }
//             if (tripType === 'round_trip' && !returnDate) {
//                 showToast('Please select a return date', 'error')
//                 return
//             }
//             searchPayload = {
//                 ...basePayload,
//                 trip_type: tripType,
//                 from_airport: fromAirport.code,
//                 to_airport: toAirport.code,
//                 departure_date: departureDate,
//                 return_date: tripType === 'round_trip' ? returnDate : null,
//             }
//             params.fromAirport = fromAirport
//             params.toAirport = toAirport
//             params.departureDate = departureDate
//             params.returnDate = tripType === 'round_trip' ? returnDate : ''
//             params.legs = []
//         }
//
//         dispatch(setSearchParams(params))
//         dispatch(setResults(null))
//         dispatch(setFlightSearching(true))
//         navigate('/flights')
//
//         ;(async () => {
//             try {
//                 const { data } = await service.post(endpoints.flights.search, searchPayload, { timeout: 45000, silent: true })
//                 dispatch(setResults(data.data))
//             } catch {
//                 // error toast already shown by the service interceptor
//             } finally {
//                 dispatch(setFlightSearching(false))
//             }
//         })()
//     }

const BusBooking = () => {
  const navigate = useNavigate()

  return (
    <>
        <section className='banner'>
            <div className='videoPart'>
                <video className='promoBanner' autoPlay loop muted playsinline="" data-object-fit="cover" preload="metadata">
                    <source src={BusVideos} type="video/mp4" />
                </video>
            </div>
            <div className='bannerContent'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <h1>Book Your Bus With Just One Click</h1>
                            <MainTab />
                        </div>
                        <div className='col-md-12'>
                            <div className='bookingAreaanner'>
                                <div className='commonBookingTab'>
                                    {TRIP_TABS.map((tab) => (
                                        <div key={tab.value} className={`bookTab ${tab.value === 'oneway' ? 'active' : ''}`}>
                                            {tab.label}
                                        </div>
                                    ))}
                                </div>

                                <div className='searchFlightArea'>
                                    <div className='flightSearchUp'>
                                        <div className='flightSearchInner'>
                                            <div className='searchInput'>
                                                <label style={{ display: 'block' }}>FROM</label>
                                                <input type='text' value='DEL' readOnly />
                                                <p>New Delhi</p>
                                            </div>
                                            <div className='swapIcon'>
                                                <img src={Swap} alt="Swap" />
                                            </div>
                                            <div className='searchInput'>
                                                <label style={{ display: 'block' }}>TO</label>
                                                <input type='text' value='BKN' readOnly />
                                                <p>Bikaner</p>
                                            </div>
                                        </div>
                                        <div className='searchInput'>
                                            <div style={{ position: 'relative' }}>
                                                <label style={{ display: 'block' }}>DEPARTURE</label>
                                                <input type='text' value='Sun, 14 Jun' readOnly style={{ paddingRight: 24 }} />
                                                <img src={Calendar} alt="" style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }} />
                                            </div>
                                        </div>
                                        <button type='button' className='commonBtn' onClick={() => navigate('/bus-list')}>
                                            Search Buses
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <PopularDestination />

        <SpecialOffer />

        <InfluencerReels />

        <GetApp />

        <OurLatestBlog />
    </>
  )
}

export default BusBooking
